module.exports = __webpack_public_path__ + "img/menu-creation-thumbnail-small.1b7ddeca.png";